import React, { useCallback } from 'react';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { sharedPluginStateHookMigratorFactory, useSharedPluginState, useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { changeAlignment } from '../editor-commands';
import { ToolbarType } from '../pm-plugins/types';
import ToolbarAlignment from './ToolbarAlignment';
var FloatingToolbarSettings = {
  disabled: false,
  isToolbarReducedSpacing: true
};
var useFloatingToolbarComponentPluginState = sharedPluginStateHookMigratorFactory(function (api) {
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['alignment'], function (states) {
      var _states$alignmentStat, _states$alignmentStat2;
      return {
        align: (_states$alignmentStat = states.alignmentState) === null || _states$alignmentStat === void 0 ? void 0 : _states$alignmentStat.align,
        isEnabled: (_states$alignmentStat2 = states.alignmentState) === null || _states$alignmentStat2 === void 0 ? void 0 : _states$alignmentStat2.isEnabled
      };
    }),
    align = _useSharedPluginState.align,
    isEnabled = _useSharedPluginState.isEnabled;
  return {
    align: align,
    isEnabled: isEnabled
  };
}, function (api) {
  var _useSharedPluginState2 = useSharedPluginState(api, ['alignment']),
    alignmentState = _useSharedPluginState2.alignmentState;
  return {
    align: alignmentState === null || alignmentState === void 0 ? void 0 : alignmentState.align,
    isEnabled: alignmentState === null || alignmentState === void 0 ? void 0 : alignmentState.isEnabled
  };
});
export function FloatingToolbarComponent(_ref) {
  var api = _ref.api,
    editorView = _ref.editorView;
  var _useFloatingToolbarCo = useFloatingToolbarComponentPluginState(api),
    align = _useFloatingToolbarCo.align,
    isEnabled = _useFloatingToolbarCo.isEnabled;
  var changeAlignmentCallback = useCallback(function (align) {
    return changeAlignment(align, api, INPUT_METHOD.FLOATING_TB)(editorView.state, editorView.dispatch);
  }, [editorView, api]);
  return /*#__PURE__*/React.createElement(ToolbarAlignment, {
    align: align,
    isReducedSpacing: editorExperiment('platform_editor_controls', 'variant1') ? false : FloatingToolbarSettings.isToolbarReducedSpacing,
    changeAlignment: changeAlignmentCallback,
    disabled: FloatingToolbarSettings.disabled || !isEnabled,
    toolbarType: ToolbarType.FLOATING,
    api: api
  });
}